import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const StyledHeader = styled.div`
    font-size: 28px;
    font-weight: 500;
    font-family: Poppins, Heltica, Arial, sans-serif;
    color: ${colors.lightGreyMidias};
    margin-bottom: 15px;
`;

export const StyledContainer = styled.div`
    border-radius: 8px;
    background-color: ${colors.light};
    font-family: Poppins, Heltica, Arial, sans-serif;
`;

export const StyledContainerHeader = styled.div`
    border-radius: 8px 8px 0 0;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.light};
    background-color: ${colors.greyMidias};
    padding: 14px 20px;
    display: flex;
    align-items: center;
    span {
        margin-left: 15px;
        height: 100%;
    }
    & svg {
        fill: ${colors.light};
        height: 21px;
        vertical-align: center;
    }
`;

export const StyledContainerContent = styled.div`
    padding: 32px;
    margin-bottom: 32px;
    box-shadow: 0px 2px 2px #9C9C9C24;
`;

export const StyledContainerTitle = styled.div`
    font-size: 20px;
    color: ${colors.darkGreyMidias};
    margin-bottom: 22px;
    font-weight: 500;
`;

export const StyledFlex = styled.div`
    display: flex;
    justify-content: ${({ justifyContent }) => (justifyContent || '')};
    flex-direction: ${({ flexDirection }) => (flexDirection || '')};
    margin: ${({ margin }) => margin};
    min-width: ${({ minWidth }) => minWidth};
    & svg {
        fill: ${colors.red};
        height: 50px;
        width: 50px;
    }
`;

export const StyledColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ReasonSmallText = styled.div`
    margin-top: ${({ marginTop }) => (marginTop || '16px')};
    color: ${colors.lightGreyMidias};
    font-size: 15px;
    min-height: ${({ minHeight }) => minHeight};
`;

export const ReasonBigText = styled.div`
    color: ${colors.darkGreyMidias};
    font-size: 27px;
    font-weight: 500;
`;

export const ReasonsFlex = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 15px;
    >div{
        max-width: 20%;
    }
`;

export const SubCardText = styled.div`
    color: ${colors.darkGreyMidias};
    font-size: 16px;
    font-weight: 500;
`;
